var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-label",class:['status-label--' + _vm.theme]},[(_vm.icon.length)?_c('FontAwesomeIcon',{attrs:{"icon":_vm.icon,"size":"sm"}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_vm._t("beside")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }